<template>
    <div class="facturas w-full h-full bg-color-01" :class="[!isCollapsed ? 'wide-table-width':'tight-table-width']">
        <div class="w-full flex items-center px-5 h-13 bg-primary-700">
          <!-- <p class="text-xs">Aprobación</p> -->
        </div>
        <div class="w-full p-2 bg-primary-800 flex items-end">
          <div class="flex flex-col pb-4 px-2 w-full">
            <label for="company" class="text-primary-200 text-sm pb-2">Empresa</label>
            <Select id="company" v-model="company" multiple placeholder="Seleccione empresa…">
              <Option
                v-for="company in companies"
                :key="company"
                :value="company">
              </Option>
            </Select>
          </div>
          <div :class="{'disabled':company == ''}" class="flex flex-col pb-4 px-2 w-full">
            <label for="location" class="text-primary-200 text-sm pb-2">Sede</label>
            <Select id="location" v-model="location" multiple placeholder="Seleccione sede…">
              <Option
                v-for="location in locations"
                :key="location"
                :value="location">
              </Option>
            </Select>
          </div>
          <div :class="{'disabled':location == ''}" class="flex flex-col pb-4 px-2 w-full">
            <label for="center" class="text-primary-200 text-sm pb-2">Centro de coste</label>
            <Select id="center" v-model="center" multiple placeholder="Seleccione centro de coste…">
              <Option
                v-for="center in centers"
                :key="center"
                :value="center">
              </Option>
            </Select>
          </div>
          <div :class="{'disabled':center == ''}" class="pb-4 px-2">
            <Button type="primary">
              <span class="hidden sm:inline-block">Buscar</span>
            </Button>
          </div>
        </div>
        <kendo-grid :data-source="searchData"
              :pageable="true"
              :filterable="true"
              :reorderable="true"
              :resizable="true"
              :sortable="true"
              :column-menu="columnMenu"
              :change="onChange"
            >
            <kendo-grid-column class="max-w-10" :width="40" :selectable="true"/>
              <kendo-grid-column :width="250" :field="'Name'"
                      :title="'Nombre'">
              </kendo-grid-column>
              <kendo-grid-column :width="250" :field="'Company'"
                      :title="'Empresa'">
              </kendo-grid-column>
              <kendo-grid-column :width="80" :field="'Level'"
                      :title="'Nivel'">
              </kendo-grid-column>
              <kendo-grid-column :width="120" :field="'Amount'"
                      :title="'Cantidad'">
              </kendo-grid-column>
        </kendo-grid>
        <transition name="modal-fade-down">
          <div class="w-full flex flex-col items-center text-light absolute text-primary-100" style="top:250px;">
            <span class="icon-factura text-primary-500 text-5xl pb-4"></span>
            <transition name="modal-fade-down">
              <span v-if="center == ''">Texto de pantalla vacía ... seleccione los campos y</span>
            </transition>
            <span>haga click en
              <span class="text-xs bg-secondary rounded text-primary-900 py-1 px-4 inline-block ml-2">Buscar</span>
            </span>
          </div>
        </transition>
      </div>
</template>
<script>
import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper'
import { Button, Select, Option } from 'element-ui'
export default {
  name: 'approval',
  components: {
    Button,
    Select,
    Option,
    'kendo-grid': Grid,
    'kendo-grid-column': GridColumn
  },
  methods: {
    onChange () {
      // this.$router.push({ name: 'documentDetail' })
      this.isSelected = true
      console.log('click en onChange')
    },
    rowClik () {
      this.$router.push({ name: 'documentDetail' })
      console.log('click en onChange')
    }
  },
  data: function () {
    return {
      isCollapsed: false,
      darkMode: true,
      columnMenu: true,
      isSelected: false,
      searchUsers: '',
      name: '',
      names: ['Hector García', 'Lucia González', 'Isabel Rodríguez', 'Abril Fernández', 'Joel López', 'Santiago Martínez', 'Luca Sánchez', 'Leire Pérez', 'Martina Gómez', 'Elia Martin'],
      company: '',
      companies: ['In Molestie', 'Tortor S.L.', 'Semper Pretium'],
      location: '',
      locations: ['Odio Auctor', 'Ridiculus Mus', 'Enim Foundation'],
      center: '',
      centers: ['Compras', 'Contabilidad', 'Legal']
    }
  }
}

</script>
